export const careManagementTestSelectors = {
  page: 'care-management-page',
  enrollmentManagerTab: {
    container: 'care-management-enrollment-manager-tab'
  },
  enrolledPatientsTab: {
    container: 'care-management-enrolled-patients-tab'
  }
};
